var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient, HttpEventType } from "@angular/common/http";
import { EncryptionHandler } from "../../app/drive/security/encryption-handler";
import { SecurityHandler } from "../../app/drive/security/security-handler";
import queue from 'async/queue';
import { Observable, Subscriber } from "rxjs";
import { DownloadEvent, DownloadEventTypes, transformAngularDownloadEvent } from "./download-progress-event";
var DownloadApiService = /** @class */ (function () {
    function DownloadApiService(http) {
        this.http = http;
        this.chunkSize = 75 * 1024 * 1024;
        this.retries = 0;
        this.maxRetries = 6;
        this.totalLoaded = 0;
        this.timeStarted = 0;
        this.totalCachedCf = 0;
        this.totalCachedEdge = 0;
        this.downloadStatus = null;
    }
    DownloadApiService.prototype.start = function (url, fileEntry) {
        var _this = this;
        this.url = url;
        this.fileEntry = fileEntry;
        return new Observable(function (observer) {
            _this.downloadStatus = observer;
            _this.download().then(function (completedEvent) {
                _this.downloadStatus.next(completedEvent);
                _this.downloadStatus.complete();
            });
        });
    };
    DownloadApiService.prototype.download = function () {
        return __awaiter(this, void 0, void 0, function () {
            var keyDec, _a, _b, edgeServer, _c, firstChunkRange, writeQueue_1, downloadQueue, completedEvent, err_1;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 9, , 10]);
                        _a = this.fileEntry.keyDec;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, new SecurityHandler().decryptKeyString(this.fileEntry.key)];
                    case 1:
                        _a = (_d.sent());
                        _d.label = 2;
                    case 2:
                        keyDec = _a;
                        this.setFileKey(keyDec);
                        this.timeStarted = Date.now();
                        _b = this;
                        return [4 /*yield*/, this.getFileMetadata()];
                    case 3:
                        _b.metadata = _d.sent();
                        return [4 /*yield*/, this.getEdgeServer()];
                    case 4:
                        edgeServer = _d.sent();
                        this.metadata.url = this.metadata.url.replace('cdn.firefile.cc', edgeServer);
                        this.chunkList = this.buildChunkList();
                        _c = this.metadata;
                        return [4 /*yield*/, this.decryptFilename(this.metadata.filename)];
                    case 5:
                        _c.filename = _d.sent();
                        this.fileStream = this.createFileStream();
                        this.fileWriter = this.createFileWriter(this.fileStream);
                        firstChunkRange = this.chunkList.slice(0, 1)[0];
                        return [4 /*yield*/, this.downloadFirstChunk(firstChunkRange)];
                    case 6:
                        _d.sent();
                        writeQueue_1 = queue(function (item, callback) {
                            _this.decryptChunk(item.blob).then(function (decryptedBlob) {
                                _this.writeChunk(_this.fileWriter, decryptedBlob).then(function () {
                                    callback();
                                });
                            });
                        }, 1);
                        downloadQueue = queue(function (chunk, callback) {
                            _this.downloadChunk(chunk).then(function (blob) {
                                writeQueue_1.push({
                                    blob: blob,
                                    chunk: chunk
                                }, function () {
                                    callback();
                                });
                            });
                        }, 1);
                        downloadQueue.push(this.chunkList.slice(1, this.chunkList.length));
                        return [4 /*yield*/, downloadQueue.drain()];
                    case 7:
                        _d.sent();
                        return [4 /*yield*/, this.fileWriter.close()];
                    case 8:
                        _d.sent();
                        this.fileWriter.releaseLock();
                        completedEvent = {
                            type: HttpEventType.Response,
                            name: DownloadEventTypes.COMPLETED,
                            fileEntry: this.fileEntry,
                            totalCachedCf: this.totalCachedCf,
                            totalCachedEdge: this.totalCachedEdge
                        };
                        return [2 /*return*/, completedEvent];
                    case 9:
                        err_1 = _d.sent();
                        console.error(err_1);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    DownloadApiService.prototype.setFileKey = function (key) {
        this.fileKey = key;
    };
    DownloadApiService.prototype.getFileStream = function () {
        return this.fileStream;
    };
    DownloadApiService.prototype.getFileWriter = function () {
        return this.fileWriter;
    };
    DownloadApiService.prototype.downloadFirstChunk = function (range) {
        return __awaiter(this, void 0, void 0, function () {
            var firstBlob, decryptedBlob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadChunk(range)];
                    case 1:
                        firstBlob = _a.sent();
                        return [4 /*yield*/, this.decryptChunk(firstBlob)
                            // free up RAM
                        ];
                    case 2:
                        decryptedBlob = _a.sent();
                        // free up RAM
                        firstBlob = null;
                        return [4 /*yield*/, this.writeChunk(this.fileWriter, decryptedBlob)
                            // free up RAM
                        ];
                    case 3:
                        _a.sent();
                        // free up RAM
                        decryptedBlob = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    DownloadApiService.prototype.downloadChunk = function (range) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            var headers = _this.buildHttpHeader(range.start, range.end);
            xhr.open('GET', _this.metadata.url, true);
            xhr.responseType = 'arraybuffer';
            Object.keys(headers).forEach(function (key) { return xhr.setRequestHeader(key, headers[key]); });
            xhr.onload = function (evt) {
                if (xhr.status == 206) {
                    _this.retries = 0;
                    _this.totalLoaded += evt.loaded;
                    /**if (xhr.getResponseHeader('cf-cache-status')) {
                        const cached: boolean = xhr.getResponseHeader('cf-cache-status').toLowerCase() == 'hit' ? true : false
                        if (cached) {
                            this.totalCachedCf += evt.loaded
                        }
                    }*/
                    if (xhr.getAllResponseHeaders().indexOf('X-Edge-Cache') >= 0) {
                        if (xhr.getResponseHeader('X-Edge-Cache')) {
                            var cached = xhr.getResponseHeader('X-Edge-Cache').toLowerCase() == 'hit' ? true : false;
                            if (cached) {
                                _this.totalCachedEdge += evt.loaded;
                            }
                        }
                    }
                    var chunkDownloadedEvent = {
                        type: 'DownloadChunkEvent',
                        name: DownloadEventTypes.CHUNK,
                        loaded: evt.loaded
                    };
                    _this.downloadStatus.next(chunkDownloadedEvent);
                    resolve(xhr.response);
                }
                else
                    xhr.onerror(evt);
            };
            xhr.onprogress = function (ev) {
                var httpEvent = {
                    type: HttpEventType.DownloadProgress,
                    loaded: _this.totalLoaded + ev.loaded,
                    total: Number(_this.metadata.size) || ev.total
                };
                var downloadEvent = transformAngularDownloadEvent(httpEvent, _this.timeStarted);
                _this.downloadStatus.next(downloadEvent);
            };
            xhr.onerror = function (err) {
                _this.retries++;
                console.error(err);
                console.log('retrying...', _this.retries);
                if (_this.retries < _this.maxRetries) {
                    setTimeout(function () {
                        _this.downloadChunk(range).then(function (data) { return resolve(data); }).catch(function (err) { return reject(err); });
                    }, 1000);
                }
                else {
                    _this.retries = 0;
                    reject(err);
                }
            };
            xhr.send();
        });
    };
    DownloadApiService.prototype.decryptChunk = function (chunk) {
        return __awaiter(this, void 0, void 0, function () {
            var iv, data, encryptionHandler, decryptedChunk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        iv = new Uint8Array(chunk.slice(0, 16));
                        return [4 /*yield*/, new Response(chunk.slice(16)).blob()
                            // free up RAM
                        ];
                    case 1:
                        data = _a.sent();
                        // free up RAM
                        chunk = null;
                        encryptionHandler = EncryptionHandler.getDecryptor(iv);
                        encryptionHandler.setIV(iv);
                        return [4 /*yield*/, encryptionHandler.setKey(this.fileKey)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, encryptionHandler.decryptBlob(data)
                            // free up RAM
                        ];
                    case 3:
                        decryptedChunk = _a.sent();
                        // free up RAM
                        data = null;
                        return [2 /*return*/, decryptedChunk];
                }
            });
        });
    };
    DownloadApiService.prototype.getFileMetadata = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.http.get(_this.url, _this.buildHttpOptionsJson(0, 1)).subscribe(function (event) {
                if (event.type == HttpEventType.Response) {
                    var metadata = {
                        filename: event.headers.get('Content-disposition').split('filename=')[1].replace(/^"(.*)"$/, '$1'),
                        size: event.headers.get('Content-Range').split('/')[1],
                        mime: event.headers.get('Content-Type'),
                        url: event.body.url,
                    };
                    resolve(metadata);
                }
            });
        });
    };
    DownloadApiService.prototype.decryptFilename = function (filename) {
        return __awaiter(this, void 0, void 0, function () {
            var securityHandler, decFilename;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        securityHandler = new SecurityHandler();
                        return [4 /*yield*/, securityHandler.decryptString(filename, this.fileKey)];
                    case 1:
                        decFilename = _a.sent();
                        return [2 /*return*/, decFilename];
                }
            });
        });
    };
    DownloadApiService.prototype.createFileStream = function () {
        var window = this.getWindow();
        var streamSaver = window.streamSaver;
        streamSaver.mitm = 'https://firefile.cc/mitm.html';
        return streamSaver.createWriteStream(this.metadata.filename, {
            size: this.metadata.size
        });
    };
    DownloadApiService.prototype.createFileWriter = function (fileStream) {
        return fileStream.getWriter();
    };
    DownloadApiService.prototype.writeChunk = function (fileWriter, chunk) {
        return new Promise(function (resolve, reject) {
            var readableStream = new Response(chunk).body;
            var reader = readableStream.getReader();
            var pump = function () { return reader.read().then(function (res) {
                res.done ? resolve() : fileWriter.write(res.value).then(pump);
            }).catch(function (err) { return reject(err); }); };
            pump();
        });
    };
    DownloadApiService.prototype.buildChunkList = function () {
        var size = Number(this.metadata.size);
        this.chunkSize += 32;
        var chunkCount = Math.ceil(size / this.chunkSize);
        var chunks = [];
        for (var i = 0; i < chunkCount; i++) {
            //let start: number = (i * this.chunkSize) + (i * 1)
            var start = i * this.chunkSize;
            var end = start + this.chunkSize - 1;
            if (end > size) {
                var diff = end - size;
                end -= diff;
            }
            var range = {
                start: start,
                end: end
            };
            chunks.push(range);
        }
        return chunks;
    };
    DownloadApiService.prototype.getEdgeServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('https://dns.firefile.cc/edge', {
                            responseType: 'text'
                        }).toPromise()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    DownloadApiService.prototype.getWindow = function () {
        var _window = window;
        return _window;
    };
    DownloadApiService.prototype.buildHttpHeader = function (offset, length) {
        return {
            'Range': 'bytes=' + offset + '-' + length
        };
    };
    DownloadApiService.prototype.buildHttpOptionsJson = function (offset, length) {
        var options = {
            headers: {
                'Range': 'bytes=' + offset + '-' + length
            },
            observe: 'events',
            responseType: 'json',
            reportProgress: true
        };
        return options;
    };
    return DownloadApiService;
}());
export { DownloadApiService };
